"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var utils_1 = require("./utils");

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var Box_1 = __importDefault(require("@material-ui/core/Box"));

var Card_1 = __importDefault(require("@material-ui/core/Card"));

var CardActions_1 = __importDefault(require("@material-ui/core/CardActions"));

var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));

var CardMedia_1 = __importDefault(require("@material-ui/core/CardMedia"));

var Skeleton_1 = __importDefault(require("@material-ui/lab/Skeleton"));

var DropIcon_1 = __importDefault(require("./DropIcon"));

var get_1 = __importDefault(require("lodash/get"));

exports.DropPreviewContainer = function (_a) {
  var children = _a.children;
  return react_1.default.createElement("div", {
    style: {
      width: 290
    }
  }, children);
};

exports.DropPreview = function (_a) {
  var drop = _a.drop,
      loading = _a.loading,
      _b = _a.imgSize,
      imgSize = _b === void 0 ? 266 : _b,
      className = _a.className;
  return react_1.default.createElement(Card_1.default, {
    elevation: 4,
    style: {
      backgroundColor: '#f8f9fa',
      color: '#262525',
      width: '100%'
    }
  }, react_1.default.createElement(Box_1.default, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 1,
    style: {
      padding: 12
    }
  }, react_1.default.createElement(DropIcon_1.default, {
    style: {
      height: 18,
      width: 18,
      marginRight: 4
    }
  }), react_1.default.createElement("small", {
    style: {
      opacity: 0.5
    }
  }, react_1.default.createElement("strong", null, "Sponsored Geodrop")), react_1.default.createElement(Box_1.default, {
    flexGrow: 1
  }), loading ? react_1.default.createElement(Skeleton_1.default, {
    variant: "text",
    width: 40,
    className: "skeleton",
    style: {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  }) : react_1.default.createElement(Typography_1.default, {
    color: "inherit",
    style: {
      opacity: 0.8,
      whiteSpace: 'nowrap'
    },
    component: "small"
  }, drop && typeof drop.amount === 'number' ? react_1.default.createElement(Box_1.default, {
    display: "flex",
    alignItems: "center",
    component: "small"
  }, react_1.default.createElement("span", {
    style: {
      transform: 'translateY(-1px)'
    }
  }, "+"), drop.amount, " COIN") : '--')), react_1.default.createElement(CardMedia_1.default, {
    className: loading ? 'skeleton' : '',
    image: get_1.default(drop, 'base64Image') || get_1.default(drop, 'imageUrl') || '',
    style: {
      height: imgSize,
      width: imgSize,
      backgroundSize: 'cover',
      textAlign: 'center',
      boxSizing: 'border-box',
      margin: 'auto'
    }
  }, get_1.default(drop, 'base64Image') || get_1.default(drop, 'imageUrl') ? null : react_1.default.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      backgroundColor: "rgba(0,0,0,0.2)"
    }
  })), react_1.default.createElement(CardContent_1.default, {
    style: {
      padding: 12,
      paddingBottom: 0
    }
  }, react_1.default.createElement(Box_1.default, {
    textAlign: "center"
  }, loading ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Skeleton_1.default, {
    variant: "text",
    width: 40,
    className: "skeleton",
    style: {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  }), react_1.default.createElement(Skeleton_1.default, {
    variant: "text",
    width: 160,
    className: "skeleton",
    style: {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  })) : react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Typography_1.default, {
    color: "inherit",
    variant: "body2",
    component: "div",
    style: {
      paddingBottom: 12
    }
  }, react_1.default.createElement("strong", null, drop && drop.title || 'Geodrop Collected')), react_1.default.createElement(Typography_1.default, {
    color: "inherit",
    variant: "body2",
    dangerouslySetInnerHTML: {
      __html: utils_1.parseMessage(drop && drop.message || "Congrats! You just found a Geodrop box.")
    },
    style: {
      wordBreak: 'break-word'
    }
  })))), react_1.default.createElement(CardActions_1.default, {
    style: {
      padding: 12
    }
  }, react_1.default.createElement(Button_1.default, {
    component: "div",
    disableElevation: true,
    style: {
      textTransform: 'none',
      color: '#aaa',
      border: '1px solid #999'
    },
    size: "small",
    variant: "outlined",
    fullWidth: true
  }, react_1.default.createElement("strong", null, "No Thanks")), react_1.default.createElement(Button_1.default, {
    component: "div",
    disableElevation: true,
    style: {
      color: '#fff',
      textTransform: 'none'
    },
    onClick: function onClick(ev) {
      ev.stopPropagation();

      if (drop && drop.link) {
        window.open(drop.link);
      }
    },
    size: "small",
    color: "secondary",
    variant: "contained",
    fullWidth: true
  }, react_1.default.createElement("strong", null, drop && drop.buttonText || 'Learn More'))));
};